import { gql } from "@apollo/client";

export const CREATE_SENTINEL = gql`
  mutation CreateSentinelMutation($input: CreateSentinelInput!) {
    createSentinel(input: $input) {
      ok
      error
      id
    }
  }
`;

export const SENTINELS = gql`
  query SentinelsQuery(
    $limit: Int
    $offset: Int
    $where: SentinelsFiltersInput!
  ) {
    sentinels(limit: $limit, offset: $offset, where: $where) {
      hasMore
      total
      results {
        id
        ip
        name
      }
    }
  }
`;

export const SENTINEL = gql`
  query SentinelQuery($id: Int!) {
    sentinel(id: $id) {
      ok
      error
      result {
        id
        name
        ip
      }
    }
  }
`;

export const UPDATE_SENTINEL = gql`
  mutation UpdateSentinelMutation($id: Int!, $input: UpdateSentinelInput!) {
    updateSentinel(id: $id, input: $input) {
      ok
      error
    }
  }
`;
